import React, { useContext } from "react";
import PsContext from "./context";

export default function ThemeLoader() {
  const context = useContext(PsContext);

  const formatColor = (c) => {
    if (!c) return null;
    let trimmed = c.trim();
    if (
      !trimmed.startsWith("#") &&
      (trimmed.length === 3 ||
        trimmed.length === 4 ||
        trimmed.length === 6 ||
        trimmed.length === 8)
    ) {
      return `#${trimmed}`;
    }
    return trimmed;
  };

  const primary =
    formatColor(context?.settingValue?.("admission_header_bg")) || "#FFF";
  const secondary =
    formatColor(context?.settingValue?.("admission_header_bg_secondary")) ||
    "#081854";
  const main_theme_color =
    formatColor(context?.settingValue?.("admission_main_theme")) || "#000000ff";

  const light =
    formatColor(context?.settingValue?.("admission_light_color")) || "#f8f9fa";
  const text_primary_color =
    formatColor(context?.settingValue?.("text_primary_color")) || "#000000ff";
  const text_secondary_color =
    formatColor(context?.settingValue?.("text_secondary_color")) || "#000000ff";

  return (
    <style>
      {`
        :root {
          --primary: ${primary};
          --secondary: ${secondary};
          --main: ${main_theme_color};
          --light: ${light};
          --text-primary-color: ${text_primary_color};
          --text-secondary-color: ${text_secondary_color};
        }
      `}
    </style>
  );
}
